const isContentfulAsset = (url: string): boolean => {
  return url.includes('images.ctfassets.net')
}
export default isContentfulAsset
